define('collections/note/notes',[
    'underscore',
    'backbone',
    'mustache',
    'utils',
    // custom
    'services/api',
    // super class
    'src/plugins/infinite-collection',
    // models
    'models/note/note'
], function(
    _, Backbone, Mustache, U,
    API,
    InfiniteCollection,
    MNote
) {
    var imagesExtensions = ['jpg', 'png', 'bmp', 'tiff', 'jpeg'];

    var CNotes = InfiniteCollection.extend({
        model: MNote,

        state: {
            pageSize: 5,
            sortKey: 'date',
            order: 1,
        },

        // sort by date as UTC string (reverse chronological order)
        comparator: function(a, b) {
            return -a.get('date').localeCompare(b.get('date'));
        },

        url: function() {
            return API.url(Mustache.render("groups/{{{group}}}/users/{{{user}}}/notes/", {
                user: this.user,
                group: this.group
            }));
        },

        initialize: function(models, opt) {
            opt = opt || {};
            this.setUser(opt.user, opt.group);

            this.listenTo(this, 'update reset', this.onCollectionUpdate);
        },

        setUser: function(userId, groupId) {
            this.user = userId;
            this.group = groupId;
        },

        setAttachmentsIcon: function() {
            var typeFile = "",
                isPicture = false;

            this.each(function(message) {
                var attachments = message.get('attachment');
                if (!attachments || attachments.length == 0) {
                    return;
                }

                attachments.forEach(function(attachment) {
                    if (!attachment || !attachment.name) {
                        return;
                    }

                    typeFile = attachment.name.split('.').pop().toLowerCase();
                    isPicture = attachment.isPicture = imagesExtensions.indexOf(typeFile) > -1;
                    attachment.icon = isPicture ? 'sl-icon-picture' : 'sl-icon-paper-clip';
                    attachment.display_url = window.env.OLD_ORIGIN + 'uploads/notes_files/' + attachment.url.split('/').pop();
                }, this)
            }, this);

            return this;
        },

        prepareCollection: function() {
            this.setAttachmentsIcon();
        },

        onCollectionUpdate: function() {
            this.prepareCollection();
        },
    });

    return CNotes;
});

